<template>
  <div>
    <div v-if="!canContinue">
      <custom-callout border-color="orange" :has-toggle="false">
        <div class="py-2">
          <div class="d-flex">
            <icon-view
              class="mt-5 mb-3 mt-md-0 mt-sm-5"
              :gradient="false"
              icon="far fa-file-invoice p-2"
              icon-background="#ff7058"
              icon-color="white"
              icon-size="14px"
              title="Añadir Solicitud de PSF"
            />
          </div>
          <validation-observer ref="formObserver">
            <div class="row p-2">
              <div class="col-md-3">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="model.area"
                    class="w-100"
                    :custom-error-msg="'El área es requerida.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Área:"
                    :options="collections.areas"
                    placeholder="Seleccione"
                    @input="onAreaChange"
                  />
                </validation-provider>
              </div>

              <div class="col-md-3">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="model.service"
                    class="w-100"
                    :custom-error-msg="'El servicio es requerida.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Servicio a Ofrecer:"
                    :options="services"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div class="col-md-3">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-drop-down
                    v-model="model.contractType"
                    class="w-100"
                    :custom-error-msg="'El tipo de contratación es requerido.'"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Tipo de Contratación:"
                    :options="collections.contractTypes"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div class="col-md-3">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-input
                    v-model="model.name"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Nombre:"
                    :maxlength="'100'"
                    placeholder="Escriba el nombre"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3">
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mr-3 pl-3 pr-4"
                @click="onCancelHandler"
              />
              <action-button
                i="fas fa-arrow-circle-right"
                text="Continuar"
                variant="success pl-3 pr-3"
                @click="onSaveHandler"
              />
            </div>
          </validation-observer>
        </div>
      </custom-callout>
    </div>
    <div v-else class="">
      <section-title
        content="Contratación de Servicios Profesionales"
        icon="fas fa-bell"
        reverse
      />

      <div style="width: 100%; height: 100%">
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          Según dispuesto en la reglamentación federal, en lo que concierne a la
          adquisición de servicios bajo asignaciones de fondos federales, los
          estados se rigen bajo los procesos y políticas que utilizan para
          fondos no federales
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          (sección 200.317 del Título 2 del Código de Reglamentación Federal (2
          CFR 200.317)).
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          Asimismo, la sección
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          200.459
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          del Título 2 del Código de Reglamentación Federal
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          (2 CFR 200.459)
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          , bajo los principios de costos, define en términos amplios los
          servicios profesionales y de consultoría como aquellos servicios
          prestados por personas que son miembros de una profesión en particular
          o poseen una habilidad especial, y que no son funcionarios empleados
          de la entidad no federal, en este caso, el DEPR.
          <br />
          <br />
          La
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          Ley núm. 237 de 2004
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          , según enmendada,
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          “Ley para establecer parámetros uniformes en los procesos de
          contratación de servicios profesionales o consultivos para las
          agencias y entidades gubernamentales del Estado Libre Asociado de
          Puerto Rico, y para otros fines”
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          dispone sobre los asuntos relacionados con la contratación de
          servicios profesionales o consultivos. Sin embargo, no establece un
          procedimiento o mecanismo en particular que deba utilizarse para
          seleccionar la persona natural o jurídica con quien se van a contratar
          los servicios profesionales o consultivos. No obstante, el DEPR,
          mediante esta guía, ha establecido procesos de adquisición directa,
          cuando aplique, o competencia para la selección de servicios
          profesionales y/o consultivos de forma tal que resulten en la mejor
          oferta para esta agencia.
          <br />
          <br />
          Todo proceso para la adquisición de servicios profesionales y/o
          consultivos en este proceso se originará mediante una
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          solicitud (PSF 1 (a) o PSF 1 (b))
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          para la revisión y aprobación de la
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 700; line-height: 16.80px; word-wrap: break-word"
        >
          Unidad de Adjudicación de Fondos (UAF).
        </span>
        <span
          style="color: black; font-size: 14px; font-family: Lato; font-weight: 400; line-height: 16.80px; word-wrap: break-word"
        >
          Esta debe contener una descripción del servicio que se peticiona, una
          justificación sobre la necesidad, vigencia, requisitos relacionados,
          estimado de costo, fuente de financiamiento y cualquier otro documento
          necesario para la evaluación adecuada del servicio. En el caso de
          enmiendas y renovaciones, también debe indicar qué contrato se
          solicita para enmendar o renovar.
          <br />
          <br />
        </span>
        <span class="text-bold">
          Para la evaluación de los servicios profesionales la UAF, además,
          deberá considerar los siguientes elementos:
          <br />
        </span>
        <span class="text-normal">
          <ol>
            <li>
              El servicio es permisible y en beneficio del programa federal que
              los sufragará.
            </li>
            <li>
              Se justifican las actividades, tareas o servicios que se proponen
              realizar.
            </li>
            <li>
              Si existe un impacto en los servicios de un programa federal o no
              federal distinto del indicado en la solicitud de servicio. Si de
              la evaluación surge que los servicios impactan más de un programa,
              la Unidad Contratante deberá identificar los fondos
              correspondientes con cargos en proporción al impacto de los
              servicios en los programas.
            </li>
            <li>
              Los servicios a solicitar no deben formar parte de los costos
              indirectos reclamados o a reclamar por el DEPR.
            </li>
            <li>
              Los servicios que solicitarán tienen el propósito de complementar
              y no reemplazar o sustituir actividades que deban ser sufragadas
              con fondos estatales, locales o de otros programas federales;
              excepto que por disposición de una ley federal se indique lo
              contrario.
            </li>
          </ol>
        </span>
      </div>
      <validation-observer ref="formObserverPart2">
        <section-title
          content="Certificación de Ausencia de Conflicto de Interes"
          icon="fas fa-bell"
          reverse
        />

        <div class="row">
          <div class="col-md-auto">Yo,</div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="representativeName"
                v-model="model.representativeName"
                custom-error-msg="El campo es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-auto">
            en mi carácter personal y en representación de
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="representativeBusiness"
                v-model="model.representativeBusiness"
                custom-error-msg="El campo es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-auto">
            (nombre de la compañía, corporación, sociedad o individuo),
          </div>
        </div>

        <div class="row mt-3 mb-5">
          <div class="col-md-auto">mayor de edad,</div>
          <div class="col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="representativeMaritalStatus"
                v-model="model.representativeMaritalStatus"
                custom-error-msg="El campo es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-auto">
            (estado civil),
          </div>
          <div class="col-md-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="representativePosition"
                v-model="model.representativePosition"
                custom-error-msg="El campo es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-auto">
            (cargo o puesto que ocupa en la entidad) y vecino de
          </div>
          <div class="col-md">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="representativeAddress"
                v-model="model.representativeAddress"
                custom-error-msg="El campo es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="col-md-auto">
            , (domicilio).
          </div>
        </div>

        <span class="text-bold">
          Certifico lo siguiente:
          <br />
        </span>
        <span class="text-normal">
          <ol>
            <li>
              Ningún servidor público de esta agencia ejecutiva tiene interés
              pecuniario en este contrato, compra o transacción comercial, y
              tampoco ha tenido en los últimos cuatro (4) años directa o
              indirectamente interés pecuniario en este negocio.
            </li>
            <li>
              Ningún servidor público de esta agencia ejecutiva me solicitó o
              aceptó, directa o indirectamente, para él, para algún miembro de
              su unidad familiar4 o para cualquier persona, regalos,
              gratificaciones, favores, servicios, donativos, préstamos o
              cualquier otra cosa de valor monetario.
            </li>
            <li>
              Ningún servidor público me solicitó o aceptó bien alguno de valor
              económico, vinculados a esta transacción, de persona alguna de mi
              entidad como pago por realizar los deberes responsabilidades de su
              empleo.
            </li>
            <li>
              Ningún servidor público me solicitó, directa o indirectamente,
              para él, para algún miembro de su unidad familiar, ni para
              cualquier otra persona, negocio o entidad, bien alguno de valor
              económico, incluyendo regalos, préstamos, promesas, favores o
              servicios a cambio de que la actuación de dicho servidor público
              esté influenciada a favor mío o de mi entidad.
            </li>
            <li>
              No tengo relación de parentesco, dentro del cuarto grado de
              consanguinidad y segundo por afinidad, con ningún servidor público
              que tenga facultad para influenciar y participar en las decisiones
              institucionales de esta agencia ejecutiva.
            </li>
            <li>
              No represento intereses particulares en casos o asuntos que
              impliquen conflicto de intereses, o de política pública, entre la
              agencia ejecutiva y los intereses particulares que represento.
            </li>
          </ol>
        </span>

        <validation-provider
          v-slot="{ errors }"
          name="certificaction"
          rules="required"
        >
          <custom-checkbox-single-option
            ref="customCheckboxRef"
            v-model="certified"
            class="custom-single-option amendment-document__checkbox"
            custom-error-msg="Debe aceptar los Términos y Condiciones para continuar con la creación de la solicitud."
            :error="errors[0]"
            :option-text="item.question"
            :title="item.questionTitle"
          />
        </validation-provider>
      </validation-observer>

      <div class="d-flex justify-content-end mt-3">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 pl-3 pr-4"
          @click="onCancelHandler"
        />
        <action-button
          i="fas fa-arrow-circle-right"
          text="Continuar"
          variant="success pl-3 pr-3"
          @click="onSaveHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import { getServiceTypesByArea } from '@/modules/serviceProposalHistory/api';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import alertMixin from '@/mixins/alert.mixin.js';
import { save } from '@/modules/purchaseService/api.js';

export default {
  name: 'PurchaseServiceAdd',
  components: {
    CustomCallout,
    ActionButton,
    CustomDropDown,
    IconView,
    SectionTitle,
    CustomInput,
    CustomCheckboxSingleOption,
  },
  mixins: [alertMixin],
  props: {
    collections: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      certified: null,
      item: {
        question: `Aceptar Términos y Condiciones`,
        questionTitle:
          'Por la presente certifico que la información, datos, hechos expuestos y documentación que se incluye en el presente documento son ciertos y correctos, y cumplen con las normas y reglamentos aplicables. Consiento a que cualquier información y/o documentación falsa, ficticia o fraudulenta, o la omisión de cualquier hecho material, puede conllevar sanciones penales, civiles o administrativas por fraude, falsas declaraciones, afirmaciones falsas o de otro tipo. Entiendo y reconozco las implicaciones legales de carácter civil y penal que conlleva esta certificación en caso de que la misma sea falsa o incorrecta.',
      },
      services: [],
      canContinue: false,
      model: {
        area: null,
        name: null,
        service: null,
        contractType: null,
        representativeName: null,
        representativeBusiness: null,
        representativeMaritalStatus: null,
        representativePosition: null,
        representativeAddress: null,
      },
    };
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onAreaChange(area) {
      this.services = [];
      this.model.service = null;
      if (!area) return;

      const { data } = await getServiceTypesByArea(area.id);
      this.services = data;
    },
    async onContinueHandler() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      this.canContinue = true;
      this.$emit('mark-adding', true);
    },
    async onSaveHandler() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      const { data } = await save({
        areaId: this.model.area.id,
        name: this.model.name,
        serviceId: this.model.service.id,
        contractTypeId: this.model.contractType.id,
        representativeName: this.model.representativeName,
        representativeBusiness: this.model.representativeBusiness,
        representativeMaritalStatus: this.model.representativeMaritalStatus,
        representativePosition: this.model.representativePosition,
        representativeAddress: this.model.representativeAddress,
      });

      this.onCancelHandler();

      if (data) {
        this.$router.push({
          name: 'purchaseServiceDetail',
          params: {
            id: data,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .dot {
    width: 30px !important;
    height: 30px !important;
  }
}

// Estilos generales para los textos
.text-normal {
  color: black;
  font-size: 14px;
  font-family: Lato;
  font-weight: 400;
  line-height: 16.8px;
  word-wrap: break-word;
}

.text-bold {
  color: black;
  font-size: 14px;
  font-family: Lato;
  font-weight: 700;
  line-height: 16.8px;
  word-wrap: break-word;
}

li {
  line-height: 30px;
}
</style>
